<script lang="ts">
	import Icon from './Icon.svelte';

	let {
		icon = 'users',
		iconSize = 48,
		title,
		description,
		actionText,
		onAction,
		class: className = ''
	}: {
		icon?: string;
		iconSize?: number;
		title: string;
		description: string;
		actionText?: string;
		onAction?: () => void;
		class?: string;
	} = $props();
</script>

<div class="py-12 text-center {className}">
	<Icon name={icon} size={iconSize} class="mx-auto mb-4 text-gray-400" />
	<h3 class="mb-2 text-lg font-medium text-gray-900">
		{title}
	</h3>
	<p class="mb-4 text-gray-600">
		{description}
	</p>
	{#if actionText && onAction}
		<button
			onclick={onAction}
			class="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
		>
			<Icon name="plus" size={20} />
			{actionText}
		</button>
	{/if}
</div>
